import React, { Component } from 'react'
import { Segment, Header, Comment, Form, Button } from 'semantic-ui-react'

class ReportCaseCommentsSection extends Component {
    renderComments() {
        const comments = this.props.reportCase?.comments || []
        if (!comments.length) return <p>No comments yet.</p>

        return (
            <Comment.Group>
                {comments.map((c, i) => (
                    <Comment key={i}>
                        <Comment.Content>
                            <Comment.Author>{c.name || 'User'}</Comment.Author>
                            <Comment.Metadata>
                                {c.createdAt ? new Date(c.createdAt).toLocaleString() : ''}
                            </Comment.Metadata>
                            <Comment.Text>{c.message}</Comment.Text>
                        </Comment.Content>
                    </Comment>
                ))}
            </Comment.Group>
        )
    }

    render() {
        return (
            <Segment>
                <Header as='h4'>Comments</Header>

                {this.renderComments()}

                <Form reply>
                    <Form.TextArea
                        value={this.props.newComment}
                        onChange={(e) => this.props.onChangeNewComment(e.target.value)}
                    />
                    <Button
                        content='Add Comment'
                        labelPosition='left'
                        icon='edit'
                        primary
                        onClick={this.props.onAddComment}
                    />
                </Form>
            </Segment>
        )
    }
}

export default ReportCaseCommentsSection